import PropTypes from 'prop-types';
import {
  Timeline,
  TimelineItem,
  TimelineSeparator,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineOppositeContent,
} from '@mui/lab';
import { Typography, Box, Chip } from '@mui/material';

import EmptyContent from '../../../components/empty-content/empty-content';
import { fDate } from '../../../utils/formatDate';

// Renders the assignment history of an asset as a vertical timeline.
// Each entry: who held it, when assigned, when returned, and any notes.
export default function AssetHistoryTimeline({ history }) {
  if (!history?.length) {
    return <EmptyContent title="No assignment history" sx={{ py: 6 }} />;
  }

  return (
    <Timeline
      sx={{
        p: 0,
        m: 0,
        [`& .MuiTimelineItem-root:before`]: { flex: 0, p: 0 },
      }}
    >
      {history.map((entry, index) => (
        <TimelineItem key={entry.id ?? index}>
          <TimelineOppositeContent sx={{ flex: 0.25, color: 'text.secondary' }}>
            <Typography variant="caption">{fDate(entry.assignedAt)}</Typography>
          </TimelineOppositeContent>
          <TimelineSeparator>
            <TimelineDot color={entry.isCurrent ? 'success' : 'grey'} />
            {index < history.length - 1 && <TimelineConnector />}
          </TimelineSeparator>
          <TimelineContent sx={{ pb: 3 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Typography variant="subtitle2">{entry.userName || 'Unknown user'}</Typography>
              {entry.isCurrent && <Chip size="small" color="success" label="Current" />}
            </Box>
            <Typography variant="body2" color="text.secondary">
              Assigned {fDate(entry.assignedAt)}
              {entry.assignedByName ? ` by ${entry.assignedByName}` : ''}
              {entry.returnedAt ? ` · Returned ${fDate(entry.returnedAt)}` : ' · Still held'}
            </Typography>
            {entry.notes && (
              <Typography variant="body2" sx={{ mt: 0.5, fontStyle: 'italic' }}>
                “{entry.notes}”
              </Typography>
            )}
          </TimelineContent>
        </TimelineItem>
      ))}
    </Timeline>
  );
}

AssetHistoryTimeline.propTypes = {
  history: PropTypes.array,
};
